import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '@utils';

const apiScope = import.meta.env.VITE_B2C_API_SCOPE;

const loginRequest = {
  scopes: [apiScope],
};

const tokenRequest = {
  scopes: [apiScope],
};

export const getToken = async (): Promise<string> => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts === null || accounts.length < 1) {
    sessionStorage.clear();
    await msalInstance.loginRedirect(loginRequest);
    throw new Error('No authenticated account found');
  }

  const activeAccount = msalInstance.getActiveAccount();
  if (activeAccount === null) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
    if (!tokenResponse.accessToken || tokenResponse.accessToken === '') {
      sessionStorage.clear();
      await msalInstance.acquireTokenRedirect(tokenRequest);
      throw new Error('Failed to acquire access token');
    }

    return tokenResponse.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      sessionStorage.clear();
      await msalInstance.acquireTokenRedirect(tokenRequest);
      throw new Error('Interaction required for authentication');
    }
    throw error;
  }
};

export const fetchWithToken = async (
  input: RequestInfo,
  init?: RequestInit,
): Promise<Response> => {
  const token = await getToken();

  const o = init ?? {};

  o.headers = new Headers(init?.headers);
  o.headers.set('Authorization', `Bearer ${token}`);
  o.headers.set(
    'Ocp-Apim-Subscription-Key',
    `${import.meta.env.VITE_APIM_API_KEY as string}`,
  );

  return await fetch(input, o);
};
